import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import DealCard from './DealCard';
import React from 'react';
import { useDeals } from "../hooks";
import { categoryNames } from '../constant';
import AdSense from 'react-adsense';
import Translate from "../components/Translate";
import { useHistory } from 'react-router-dom';
import { useCategory } from '../hooks';

const DealCarousel = props => {
	const [deals] = useDeals();
	const history = useHistory();
	const [, setCategory] = useCategory();
  
	const routeChange = React.useCallback(path => {
	  history.push(path);
	}, [history]);

	const { dcat, dstore, setModalOpen, setStore, setGuide } = props;

	const dcats = ['1','13','11','3','5','15','7','9', '23']; //dcat.split(',').filter(cat => cat !== '1' && cat !== '42');

	let catsDeals = {};
	dcats.forEach(cat => {
		catsDeals = { ...catsDeals, [cat]: deals.filter(deal => deal.dcat.split(',').includes(cat)) };
	});

	let dealCards = {};
	Object.keys(catsDeals).forEach(key => {
		const cards = catsDeals[key].sort(() => Math.random() - 0.5).splice(0, 15).map(deal => (
			<DealCard
				deal={deal}
				key={deal.dno}
				setModalOpen={setModalOpen}
				setStore={setStore}
				setGuide={setGuide}
				style={{ padding: '10px' }}
				cardMargin="auto"
			/>));
		dealCards = { ...dealCards, [key]: cards };
	});

	const storeDeals = deals.filter(deal => deal.dstore === dstore);

	const storeCards = React.useMemo(() => storeDeals.sort(() => Math.random() - 0.5).splice(0, 15).map(deal => (
		<DealCard
			deal={deal}
			key={deal.dno}
			setModalOpen={setModalOpen}
			setStore={setStore}
			setGuide={setGuide}
			style={{ padding: '10px' }}
			cardMargin="auto"
		/>)), [storeDeals, setModalOpen, setStore, setGuide]);

	const responsive = {
		large: {
			breakpoint: { max: 3000, min: 2500 },
			items: 6,
			slidesToSlide: 1, // optional, default to 1.
		},
		small: {
			breakpoint: { max: 2500, min: 1800 },
			items: 5,
			slidesToSlide: 1, // optional, default to 1.
		},
		desktop: {
			breakpoint: { max: 1800, min: 1200 },
			items: 4,
			slidesToSlide: 1, // optional, default to 1.
		},
		tablet: {
			breakpoint: { max: 1200, min: 900 },
			items: 3,
			slidesToSlide: 1, // optional, default to 1.
		},
		mobile: {
			breakpoint: { max: 900, min: 600 },
			items: 2,
			slidesToSlide: 1, // optional, default to 1.
		},
		tiny: {
			breakpoint: { max: 600, min: 0 },
			items: 1,
			slidesToSlide: 1, // optional, default to 1.
		},
	};

	const goCategory = React.useCallback((cat) => {
		setCategory(cat);
		routeChange("/category");
	  }, [setCategory, routeChange]);

	const catCarousels =
		dcats.map(key => {
			const carousel = (
				<React.Fragment key={key}>
					{/* <AdSense.Google
						client='ca-pub-3072979906851512'
						slot='3922802401'
						style={{ display: 'block', }}
						layout='in-article'
						format='fluid'
						responsive='true'
					/> */}
					<h4 style={{ marginTop: '1rem' }} onClick={()=>{goCategory(key)}}>{Translate('更多')}<a href="#">{categoryNames[key]}{Translate("折扣")} >>></a></h4>
					<hr />
					<Carousel
						key={key}
						swipeable={true}
						draggable={true}
						showDots={true}
						responsive={responsive}
						ssr={true} // means to render carousel on server-side.
						infinite={true}
						autoPlay={false}
						autoPlaySpeed={5000}
						keyBoardControl={true}
						customTransition="transform 500ms ease-in-out"
						transitionDuration={500}
						containerClass="carousel-container"
						dotListClass="custom-dot-list-style"
						itemClass="carousel-item-padding-40-px"
					>
						{dealCards[key]}
					</Carousel>
				</React.Fragment>
			);
			return carousel;
		});

	const storeCarousel = (
		<React.Fragment>
			{/* <AdSense.Google
				client='ca-pub-3072979906851512'
				slot='3922802401'
				style={{ display: 'block', }}
				layout='in-article'
				format='fluid'
				responsive='true'
			/> */}
			<h4 style={{ marginTop: '1rem' }}>More from {dstore}:</h4>
			<hr />
			<Carousel
				key={dstore}
				swipeable={true}
				draggable={true}
				showDots={true}
				responsive={responsive}
				ssr={true} // means to render carousel on server-side.
				infinite={true}
				autoPlay={false}
				autoPlaySpeed={5000}
				keyBoardControl={true}
				customTransition="transform 500ms ease-in-out"
				transitionDuration={500}
				containerClass="carousel-container"
				dotListClass="custom-dot-list-style"
				itemClass="carousel-item-padding-40-px"
			>
				{storeCards}
			</Carousel>
		</React.Fragment>
	);

	const allCategory = deals.filter(deal => deal.dcat.split(',').includes('42'));
	const allCards = allCategory.sort(() => Math.random() - 0.5).splice(0, 15).map(deal => (
		<DealCard
			deal={deal}
			key={deal.dno}
			setModalOpen={setModalOpen}
			setStore={setStore}
			setGuide={setGuide}
			style={{ padding: '10px' }}
			cardMargin="auto"
		/>));
	const allCarousel = (
		<React.Fragment>
			{/* <AdSense.Google
				client='ca-pub-3072979906851512'
				slot='3922802401'
				style={{ display: 'block', }}
				layout='in-article'
				format='fluid'
				responsive='true'
			/> */}
			<h4 style={{ marginTop: '1rem' }}><a href="/"> 所有折扣 >>></a></h4>
			<hr />
			<Carousel
				key={dstore}
				swipeable={true}
				draggable={true}
				showDots={true}
				responsive={responsive}
				ssr={true} // means to render carousel on server-side.
				infinite={true}
				autoPlay={false}
				autoPlaySpeed={5000}
				keyBoardControl={true}
				customTransition="transform 500ms ease-in-out"
				transitionDuration={500}
				containerClass="carousel-container"
				dotListClass="custom-dot-list-style"
				itemClass="carousel-item-padding-40-px"
			>
				{allCards}
			</Carousel>
		</React.Fragment>
	);

	return <React.Fragment>{catCarousels}{allCarousel}</React.Fragment>;
};

export default DealCarousel;
